/* Model */
class EntityRestModel extends App.Models.BaseModel {
    modelUrl = 'EntityRest';
}

App.Models.EntityRest = EntityRestModel;

/* Collection */
class EntityRestCollection extends App.Collections.BaseCollection {
    url = 'EntityRest';
    model = App.Models.EntityRest;
}

App.Collections.EntityRests = EntityRestCollection;

/* Router */
class EntityRestRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'EntityRest';
        const model = App.Models.EntityRest;
        const collectionClass = App.Collections.EntityRests;

        super(entityName, model, collectionClass);
    }
}

App.Routers.EntityRest = EntityRestRouter;
